import { useAtom } from 'jotai'
import _ from 'lodash'

export const ABORT_ERROR_CODE = 'ABORT_ERROR'
export const TIMEOUT_ERROR_CODE = 'TIMEOUT_ERROR'

const abortErrorCause = {
  code: ABORT_ERROR_CODE,
  error: null
}
const abortError = new Error('取消請求', { cause: abortErrorCause })

const timeoutErrorCause = {
  code: TIMEOUT_ERROR_CODE,
  error: null
}
const timeoutError = new Error('請求逾時', { cause: timeoutErrorCause })

const useAbortController = (abortControllerAtom) => {
  const [controller, setController] = useAtom(abortControllerAtom)

  const abort = () => {
    controller.abort()
  }

  const reset = () => {
    setController(new AbortController())
  }

  const abortAndReset = () => {
    abort()
    reset()
  }

  const getIsAborted = (signal, error) => {
    return (
      _.get(signal, 'aborted') ||
      _.get(error, 'cause.code') === abortErrorCause.code
    )
  }

  const getIsHookError = (error) => {
    const code = _.get(error, 'cause.code')
    return code === ABORT_ERROR_CODE || code === TIMEOUT_ERROR_CODE
  }

  const waitWithAbort = (wait = 0, callback = () => {}) => {
    const { signal } = controller
    if (signal.aborted) {
      return Promise.reject(abortError)
    }
    return new Promise((resolve, reject) => {
      const onAbort = () => {
        clearTimeout(timerId)
        signal.removeEventListener('abort', onAbort)
        reject(abortError)
      }
      signal.addEventListener('abort', onAbort)
      const timerId = _.delay(() => {
        signal.removeEventListener('abort', onAbort)
        resolve(callback())
      }, wait)
    })
  }

  const fetchWithAbort = (url, init = {}, timeoutMs) => {
    const fetchPromise = fetch(url, { ...init, signal: controller.signal })
    if (timeoutMs == null) {
      return fetchPromise
    }
    const timeoutPromise = new Promise((_resolve, reject) => {
      setTimeout(() => reject(timeoutError), timeoutMs)
    })
    return Promise.race([fetchPromise, timeoutPromise])
  }

  return {
    controller,
    signal: controller.signal,
    abort,
    reset,
    abortAndReset,
    getIsAborted,
    getIsHookError,
    waitWithAbort,
    fetchWithAbort
  }
}

export default useAbortController
